import { render, staticRenderFns } from "./ProductCreateEdit.vue?vue&type=template&id=52a303c0"
import script from "./ProductCreateEdit.vue?vue&type=script&lang=js"
export * from "./ProductCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports